import {
  SUBMIT_DELIVERABLE,
  SET_INITIAL_SUBMIT_TYPE,
  UPDATE_ADD_DELIVERABLE_FORM_OPTIONS,
  SET_INITIAL_DELIVERABLE,
} from './constants';

export function submitDeliverable(deliverableData, submitType, submitDeliverableCallback) {
  return {
    type: SUBMIT_DELIVERABLE,
    deliverableData,
    submitType,
    submitDeliverableCallback,
  };
}

export function setInitialSubmitType(data) {
  return {
    type: SET_INITIAL_SUBMIT_TYPE,
    data,
  };
}

export function updateAddDeliverableForm(deliverableId, callback) {
  return {
    type: UPDATE_ADD_DELIVERABLE_FORM_OPTIONS,
    deliverableId,
    callback,
  };
}

export function setInitialDeliverable(data) {
  return {
    type: SET_INITIAL_DELIVERABLE,
    data,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/deliverable-submit-modal/actions.js
 **/